import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WifiOff } from "lucide-react";
import { api, fmtTime } from "@/lib/api";

const STALE_MS = 3 * 60 * 1000;

const isDown = (d) => !d.is_demo && d.conn_status !== "baru" &&
  (d.conn_status === "gagal" || !d.last_seen || Date.now() - new Date(d.last_seen).getTime() > STALE_MS);

export function OfflineBanner({ canManage }) {
  const [down, setDown] = useState([]);
  useEffect(() => {
    const load = () => api.get("/devices").then((r) => setDown(r.data.filter(isDown))).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!down.length) return null;
  return (
    <div data-testid="offline-banner" className="flex items-start gap-3 bg-red-600 text-white px-4 py-2 text-xs sm:text-sm">
      <WifiOff className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1 space-y-0.5">
        {down.map((d) => (
          <p key={d.id} data-testid={`offline-device-${d.name}`} className="truncate">
            <b>{d.name} tidak menjawab</b>
            {d.last_seen ? ` sejak ${fmtTime(d.last_seen)}` : ""}
            {d.conn_message ? ` — ${d.conn_message}` : ""}
          </p>
        ))}
      </div>
      {canManage && <Link to="/device" data-testid="offline-banner-link" className="shrink-0 underline underline-offset-2">Buka Device</Link>}
    </div>
  );
}
